import { PayloadAction } from '@reduxjs/toolkit';

import { LivePreviewSize, LivePreviewState } from '../types';

const setSizeReducer = (state: LivePreviewState, action: PayloadAction<LivePreviewSize>) => {
  state.size = action.payload;
};

export default setSizeReducer;
